document.addEventListener("DOMContentLoaded", function() {
    const toggleButton = document.getElementById("toggle-description-btn");
  
    if (toggleButton) {
      toggleButton.addEventListener("click", function() {
        const container = toggleButton.closest('.product-short-description');
        const descriptionContent = container.querySelector('.description-content');
        
   
        const seeMoreText = toggleButton.getAttribute('data-see-more');
        const seeLessText = toggleButton.getAttribute('data-see-less');
  
        if (descriptionContent.classList.contains('expanded')) {
          descriptionContent.classList.remove('expanded');
          toggleButton.textContent = seeMoreText;
        } else {
          descriptionContent.classList.add('expanded');
          toggleButton.textContent = seeLessText; 
        }
      });
    }
  });
  